import { HTTPRequestMethod } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';
import type { NodeDataT } from 'fable/flowEditor';

import type {
  CallFlowTypeT,
  FlowCallActionT,
  FlowCallCreateFlowT,
  FlowCallFlowT,
  GetFlowResponseT,
  UpdateFlowResponseT,
} from './types';

const base = '/v1/flows';

export function getFlow(flowID: string): Promise<CallFlowTypeT> | undefined {
  if (!flowID) {
    console.error('fetchFlow flow ID not given.');
    return undefined;
  }
  return ajaxSend<GetFlowResponseT>({
    path: `${base}/${flowID}`,
  }).then((receivedData: GetFlowResponseT) => {
    const newFlow = receivedData.data;

    const data: CallFlowTypeT = {
      active: newFlow.active,
      created: newFlow.created_at,
      hasUnSavedChanges: false,
      id: newFlow.id,
      name: newFlow.name,
      nodes: {},
      number: newFlow.location,
      status: 'complete',
      updated: newFlow.updated_at,
    };

    const nodesObject = {};

    for (const node of newFlow.actions) {
      nodesObject[node.id] = node;
    }
    data.nodes = nodesObject;

    return data;
  });
}

export function addFlow(
  flow: FlowCallCreateFlowT,
): Promise<NodeDataT<FlowCallActionT[]>> | undefined {
  if (!flow) {
    console.error('postFlowToApi flow params not given.');
    return undefined;
  }

  return ajaxSend<NodeDataT<FlowCallActionT[]>>({
    method: HTTPRequestMethod.Post,
    path: base,
    data: flow,
  });
}

export function updateFlow(
  flow: FlowCallFlowT,
): Promise<CallFlowTypeT> | undefined {
  if (!flow) {
    console.error('postFlowToApi flow params not given.');
    return undefined;
  }

  return ajaxSend<UpdateFlowResponseT>({
    method: HTTPRequestMethod.Put,
    path: `${base}/${flow.id}`,
    data: flow,
  }).then((receivedData: UpdateFlowResponseT) => {
    const newFlow = receivedData.data;

    const data: CallFlowTypeT = {
      active: newFlow.active,
      created: newFlow.created_at,
      hasUnSavedChanges: false,
      id: newFlow.id,
      name: newFlow.name,
      nodes: {},
      number: newFlow.location,
      status: 'complete',
      updated: newFlow.updated_at,
    };

    const nodesObject = {};
    for (const node of newFlow.actions) {
      nodesObject[node.id] = node;
    }
    data.nodes = nodesObject;

    return data;
  });
}
